'use client';

import { usePathname } from 'next/navigation';
import { createContext, useContext } from 'react';

export const RenderedPathnameContext = createContext<string | null>(null);

//* 루트 레이아웃(GlobalLayout) 밖에서는 세그먼트 기준을 못 잡아 주소를 그대로 쓴다
export const useRenderedPathname = () => {
  const renderedPathname = useContext(RenderedPathnameContext);
  const pathname = usePathname() ?? '';

  return renderedPathname ?? pathname;
};
